import { t } from "@lingui/macro";
import { X, Cookie, Shield, ChartLine, Megaphone } from "@phosphor-icons/react";
import { Button, Card, Switch } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";
import { useState, useEffect } from "react";

import { useCookieStore } from "@/client/stores/cookie";

export const CookieModal = () => {
  const { consent, isModalOpen, setModalOpen, acceptAll, rejectAll, acceptSelected } =
    useCookieStore();

  const [localConsent, setLocalConsent] = useState({
    analytics: false,
    marketing: false,
  });

  // Show modal if no consent has been given
  useEffect(() => {
    if (consent === null) {
      setModalOpen(true);
    }
  }, [consent, setModalOpen]);

  const handleAcceptSelected = () => {
    acceptSelected(localConsent);
  };

  const handleAcceptAll = () => {
    acceptAll();
  };

  const handleRejectAll = () => {
    rejectAll();
  };

  if (!isModalOpen) return null;

  return (
    <div className="fixed right-4 bottom-4 z-50 max-w-md">
      <Card className="bg-background/95 relative overflow-hidden rounded-xl p-4 backdrop-blur-sm">
        <div className="relative p-0">
          {/* Header */}
          <div className="mb-2 flex items-start justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-primary/10 flex h-10 w-10 items-center justify-center rounded-full">
                <Cookie className="text-primary h-5 w-5" />
              </div>
              <div>
                <h3 className="text-foreground text-lg font-semibold">{t`Cookie Preferences`}</h3>
                <p className="text-muted-foreground text-sm">{t`We use cookies to enhance your experience`}</p>
              </div>
            </div>
            <Button
              size="icon"
              variant="ghost"
              className="relative top-[-7px] right-[-7px] h-8 w-8 shrink-0"
              onClick={() => setModalOpen(false)}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>

          {/* Privacy Policy Link */}
          <p className="text-muted-foreground my-2 mb-4 text-center text-xs">
            {t`By continuing to use this site, you agree to our`}{" "}
            <a
              href="/privacy"
              className="text-primary hover:text-primary/80 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t`Privacy Policy`}
            </a>
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col gap-2 sm:flex-row sm:justify-between">
            <div className="flex gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={handleRejectAll}
                className="flex-1 sm:flex-none"
              >
                {t`Only essentials`}
              </Button>
            </div>
            <Button size="sm" onClick={handleAcceptAll} className="flex-1 sm:flex-none">
              {t`Accept All`}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
